import { render, staticRenderFns } from "./profileSidebar.vue?vue&type=template&id=9bb65db2&scoped=true&"
import script from "./profileSidebar.vue?vue&type=script&lang=js&"
export * from "./profileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./profileSidebar.vue?vue&type=style&index=0&id=9bb65db2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb65db2",
  null
  
)

export default component.exports